import InfoBlock from './InfoBlock';
import TabsBlock, { TabPanel } from './TabsBlock';
import BottomBlock from './BottomBlock';
import StakeTabPanel from './TabsBlock/StakeTabPanel';
import WithdrawTabPanel from './TabsBlock/WithdrawTabPanel';
import useGetInfo from '../../hooks/useGetInfo';
import ConnectBlock from './ConectBlock';
import useGetMyRewards from '../../hooks/useGetMyRewards';
import { useAccount } from 'wagmi';

const MyRewards = () => {
  const { address: account } = useAccount();
  const state = useGetInfo();
  const { data } = state;
  const stateRewards = useGetMyRewards();

  if (!account) {
    return <ConnectBlock />;
  }

  return (
    <div className="page-rewards">
      <div className="top-content">
        <InfoBlock stateRewards={stateRewards} data={data} />
        <TabsBlock>
          <TabPanel label="Stake">
            <StakeTabPanel stateRewards={stateRewards} state={state} />
          </TabPanel>
          <TabPanel label="Withdraw">
            <WithdrawTabPanel state={state} />
          </TabPanel>
        </TabsBlock>
      </div>
      <div className="bottom-content">
        <BottomBlock stateRewards={stateRewards} state={state} />
      </div>
    </div>
  );
};

export default MyRewards;
